declare const __APP_VERSION__: string;

export const getAppVersion = (): string => {
  return __APP_VERSION__ || 'unknown';
};

// Helper function to get just the version number (without git hash)
export const getVersionNumber = (): string => {
  const fullVersion = getAppVersion();
  return fullVersion.split('_')[0] || 'unknown';
};

// Helper function to get just the git hash
export const getGitHash = (): string => {
  const fullVersion = getAppVersion();
  const parts = fullVersion.split('_');
  return parts.length > 1 ? parts[1] : 'unknown';
};